import script from "./TopicTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicTemplate.vue?vue&type=script&setup=true&lang=js"

import "./TopicTemplate.vue?vue&type=style&index=0&id=58d1175a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d1175a"]])

export default __exports__